export const apiConstants = {
  version: 1,
  status: "status",
  code: "code",
  pin: "pin",
  email: "email",
  password: "password",
  old_password: "old_password",
  confirm_password: "confirm_password",
  data: "data",
  name: "name",
  full_name: "full_name",
  first_name: "first_name",
  last_name: "last_name",
  middle_name: "middle_name",
  mobile_number: "mobile_number",
  phone_number: "phone_number",
  company_name: "company_name",
  contact_name: "contact_name",
  address: "address",
  city: "city",
  post_code: "postcode",
  rate6: "rate6",
  rate7: "rate7",
  supplier_name: "supplierName",
  supplier_contact_name: "supplierContactName",
  service: "service",
  product: "product",
  title: "title",
  daily_rate: "daily_rate",
  location: "location",
  number_position: "numberOfPositions",
  number_of_positions: "number_of_positions",
  description: "description",
  start_date: "start_date",
  end_date: "end_date",
  image: "image",
  department: "department",
  departments: "departments",
  position: 'position',
  production: 'production',
  studio: 'studio',
  imdb_link: 'imdb_link',
  company: "company",
  website: "website",
  user_type: "user_type",
  user: "user",
  permission_type: "permission_type",
  view_type: "view_type",
  mast_format: "+99 9999 999 999",
  company_logo: "company_logo",
  contact_person: "contact_person",
  country: "country",
  postcode: "postcode",
  account_completed: "account_completed",
  seventh_day_earning_rates: "seventh_day_earning_rates",
  sixth_day_earning_rates: "sixth_day_earning_rates",
  isd_code: "isd_code",
  bio: "bio",
  profile_image: "profile_image",
  search: "search",
  role: "role",
  roles: "roles",
  id: "id",
  eventName: "name",
  group_name: "group_name",
  date: "date",
  crews: "crews",
  eventSubCategory: "sub_category",
  event_start_date: "start_datetime",
  event_end_date: "end_datetime",
  meeting_link: "meeting_link",
  event_location: "location",
  event_address: "address",
  event_type: "type",
  eventStartTime: "start_time",
  eventEndTime: "end_time",
  user_ids: "user_ids",
  message: "message",
  evt_location: "location",
  evt_timezone: "time_zone",
  coordinates: "coordinates",
  contracted_hours: "contracted_hours",
  overtime_hours: "overtime_hours",
  event_title: "event_title",
  production_id: "production_id",
  start_time: "start_time",
  end_time: "end_time",
  is_night_working: "is_night_working",
  terms_accepted: 'terms_accepted',
  dial_code: 'dial_code',
  IMDB_link: 'imdb_link',
  biography: "bio",
  working_days: 'working_days',
  reference_name: 'reference_name',
  reference_email: 'reference_email',
  reference_mobile_number: 'reference_mobile_number',
  location_id: 'location_id',
  location_note_id: 'location_note_id',
  location_space_id: 'location_space_id',
  production_company_name: 'production_company_name',
  contact_phone_number: 'contact_phone_number',
  contact_email: 'contact_email',
  shoot_rate: 'shoot_rate',
  date_scouted: 'date_scouted',
  scouting_tags: 'scouting_tags',
  headline: 'headline',
  type: 'type',

  show_type: 'show_type',
  number_of_scenes: 'number_of_scenes',
  number_of_episodes: 'number_of_episodes',
  add_locations_to_vault: 'add_locations_to_vault',
  locations_date: 'locations_date',
  create_photo_folders: 'create_photo_folders',
  location_folder_image_id: 'location_folder_image_id',

  // per-scene fields
  set_name: 'set_name',
  scene_number: 'scene_number',
  pages: 'pages',
  day_or_night: 'day_or_night',
  scene_type: 'type', // 'location' | 'set'
  episode_number: 'episode_number',
  collection: 'collection',
};
